module.exports = __webpack_public_path__ + "img/nettkonsesjoner.228e940f.jpg";